import React, { useEffect, useState } from 'react';
import { Button, Col } from 'reactstrap';

import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Component
import TextField from '../../../components/TextField/TextField';

//Helpers
import mascaras from '../../../helpers/mascaras';


export default function Bloco({ pgrs, setPgrs, bloco, setActiveStep }) {

  const [checksQuestoesObrigatorias, setChecksQuestoesObrigatorias] = useState([]);

  const options = {
    "Data": { type: "date", placeholder: "Informe uma data" },
    "Lista": { type: "select", placeholder: "Escolha uma opção" },
    "Texto": { type: "text", placeholder: "Informe o valor" },
    "Número": { type: "number", placeholder: "Informe o valor" },
  };

  const onChangeQuestao = (e, questao) => {
    if (questao.tipoValor == "Lista"){
      questao.valor = e ? e.value.toString() : null
    }
    else 
      questao.valor = e.target.value;
    
    if (questao.tipoValor === "Lista") {
      const selectedOption = questao.tbFormularioPGRSBlocoQuestaoOpcoes.find(op => op.valor === questao.valor);
      questao.inconformidade = selectedOption ? selectedOption.geraInconformidade : false;
    } else {
      questao.inconformidade = false;
    }

    setPgrs({
      ...pgrs,
      tbPGRSGeradorBlocos: pgrs?.tbPGRSGeradorBlocos.map(_bloco => {
        if (_bloco.tbFormularioPGRSBlocos_Id == bloco.id) {
          _bloco.tbPGRSGeradorBlocoQuestos = _bloco.tbPGRSGeradorBlocoQuestos.map(_questao => {
            if (_questao.tbFormularioPGRSBlocoQuestoes_Id == questao.tbFormularioPGRSBlocoQuestoes_Id)
              return questao;
            return _questao;
          })
          return _bloco;
        }

        return _bloco;
      })
    });
  };

  const validateQuestao = () => {
    const _bloco = pgrs?.tbPGRSGeradorBlocos?.filter(x => x.tbFormularioPGRSBlocos_Id == bloco.id);
    if (_bloco && _bloco[0]?.tbPGRSGeradorBlocoQuestos.filter(x => !x.valor && (x.obrigatorio == "Sim" || x.obrigatorio)).length > 0) {
      setChecksQuestoesObrigatorias(_bloco[0]?.tbPGRSGeradorBlocoQuestos.filter(x => !x.valor && (x.obrigatorio == "Sim" || x.obrigatorio)))
      return false;
    } else {
      setChecksQuestoesObrigatorias([]);
      return true;
    }
  };

  const nextQuestion = () => {
    if (validateQuestao()) {
      setChecksQuestoesObrigatorias([]);
      setActiveStep(prev => prev + 1)
    }
  };

  function btnVoltar() {
    setActiveStep(prev => prev - 1)
  }

  return (
    <div className='p-2 m-2'>
      <Col lg={12} className='mb-2'>
        {bloco &&
          pgrs &&
          pgrs?.tbPGRSGeradorBlocos &&
          pgrs?.tbPGRSGeradorBlocos.length > 0 &&
          pgrs?.tbPGRSGeradorBlocos.filter(x => x.tbFormularioPGRSBlocos_Id == bloco.id)[0] != null &&
          pgrs?.tbPGRSGeradorBlocos.filter(x => x.tbFormularioPGRSBlocos_Id == bloco.id)[0].tbPGRSGeradorBlocoQuestos.map((questao, index) => (
            <TextField
              key={index}
              invalid={
                checksQuestoesObrigatorias.length > 0 &&
                  checksQuestoesObrigatorias.some(x => x.tbFormularioPGRSBlocoQuestoes_Id == questao.tbFormularioPGRSBlocoQuestoes_Id)
                  ? true : false
              }
              type={options[questao.tipoValor].type}
              mask={questao.tipoValor === "number" ? mascaras.numeroMask : (v) => v}
              value={questao.tipoValor != "Lista" ? questao.valor : (questao?.tbFormularioPGRSBlocoQuestaoOpcoes?.map(item => {
                item.label = item.valor;
                item.value = item.valor;
                return item
              }) ?? []).filter(q => q.value == questao.valor)[0]}
              searchable
              onChange={(e) => onChangeQuestao(e, questao)}
              placeholder={options[questao.tipoValor].placeholder}
              options={questao?.tbFormularioPGRSBlocoQuestaoOpcoes?.map(item => {
                item.label = item.valor;
                item.value = item.valor;
                return item
              }) ?? []}
              label={<>{questao.obrigatorio && <span>*</span>} {questao?.descricao}</>}
            />
          ))
        }
      </Col>

      <div className='d-flex align-items-center justify-content-center mt-4'>
        <Button outline color='success' className='me-4 bg-gradient d-flex align-items-center' onClick={btnVoltar}>
          <FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior
        </Button>
        <Button color='success' className='bg-gradient d-flex align-items-center' onClick={nextQuestion}>
          Próximo <FontAwesomeIcon icon={faArrowRight} className={"ms-3"} />
        </Button>
      </div>
    </div>
  );
}
